module.exports = __webpack_public_path__ + "static/media/IconTemplates_-89.77dd589b.svg";